// extracted by mini-css-extract-plugin
module.exports = {"pg-use-box":"dk","pgUseBox":"dk","use-card-wrap":"dl","useCardWrap":"dl","use-box-wrap":"dm","useBoxWrap":"dm"};